







import {Component, Emit, Prop, Vue} from "vue-property-decorator"
import {Operation, Criterion} from "@dynamoit/shared/generated/globalTypes"
import {IconTitle} from '@/types'
import IconMenu from '@/components/IconMenu.vue'

@Component({
    components: {IconMenu}
})
export default class FilterChip extends Vue {

    @Prop({required: true})
    public criterion!: Criterion

    private get items(): IconTitle<Operation>[] {
        return [
            {icon: 'mdi-equal', title: 'Equal', value: Operation.EQUAL},
            {icon: 'mdi-not-equal-variant', title: 'Not equals', value: Operation.NOT_EQUAL},
            {icon: 'mdi-contain', title: 'Contains', value: Operation.CONTAINS},
            {icon: 'mdi-format-page-break', title: 'Not contains', value: Operation.NOT_CONTAINS},
            {icon: 'mdi-contain-start', title: 'Begins with', value: Operation.BEGINS_WITH},
            {icon: 'mdi-exclamation', title: 'Not exists', value: Operation.NOT_EXISTS}
        ]
    }

    @Emit('close')
    private onClose(): Criterion {
        return this.criterion
    }

    @Emit('input')
    private onOperationChange(item: IconTitle<Operation>): Criterion {
        return {
            ...this.criterion,
            operation: item.value
        }
    }

    private criterionAsIconTitle(criterion: Criterion) {
        return this.items.find(_ => _.value === criterion.operation) || this.items[0]
    }
}
